import React, { useEffect } from 'react'
import HubspotForm from 'react-hubspot-form';
import useStateRef from 'react-usestateref';

const HubSpotPluginForm = ({ containerObject, templateName, contentId, dataZone }) => {

    const [portalId, setPortalId, portalIdRef] = useStateRef("44059706");
    const [formId, setFormId, formIdref] = useStateRef("1a35fe82-646c-4770-99e5-c70883527d20");
    const [region, setRegion, regionref] = useStateRef("na1");
    const [url, setUrl, urlRef] = useStateRef("");
    useEffect(()=>{
        console.log("HubSpotPluginForm containerObject",containerObject);
        if(containerObject){
            var portalId = containerObject?.attributes?.portalId;
            var formId = containerObject?.attributes.formId;
            var region = containerObject?.attributes.region;
           if(portalId){
            setPortalId(portalId)
           }
           if(formId){
            setFormId(formId)
           }
           if(region){
            setRegion(region)
           }
           
            
        }
        console.log("HubSpotPluginForm portalIdRef",portalIdRef.current);
        console.log("HubSpotPluginForm formIdref",formIdref.current);
        console.log("HubSpotPluginForm regionref",regionref.current);
        setUrl(`/hubSpotForm?portalId=${portalIdRef.current}&formId=${formIdref.current}&region=${regionref.current}`);

    },[])
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-container`}>
        <HubspotForm
            portalId={portalIdRef.current}
            formId={formIdref.current}
            region={regionref.current}
            onSubmit={() => console.log('Submit!')}
        />
         {/* <iframe  style={{ "height": "785px","width": "100%"}}  src={urlRef.current} /> */}
        
        </div>
    )
}

export default HubSpotPluginForm